export default  {
    evenement: {
        "Id": 255,
        "EvenementNom": "Cocktail du Nouvel An - 16 janvier 2020",
        "Debut": "2020-01-16T17:30:00",
        "Fin": "2020-01-17T17:29:00",
        "Description": "À l’aube de cette nouvelle année, quoi de mieux que de se rassembler pour célébrer et échanger sur nos objectifs pour l’année à venir ? ",
        "PolitiqueAnnulation": "<strong>Aucune annulation ni remboursement moins de deux (2) jours ouvrables avant l’événement.&nbsp;</strong>",
    },
    activites: [
        {
            "Id": 255,
            "EvenementNom": "Activité 1 - 16 janvier 2020",
            "Debut": "2020-01-16T17:30:00",
            "Fin": "2020-01-17T17:29:00",
            "Description": "À l’aube de cette nouvelle année, quoi de mieux que de se rassembler pour célébrer et échanger sur nos objectifs pour l’année à venir ? ",
            "PolitiqueAnnulation": "<strong>Aucune annulation ni remboursement moins de deux (2) jours ouvrables avant l’événement.&nbsp;</strong>",
            "NbPlaceDisponibles": 50,
        },
        {
            "Id": 256,
            "EvenementNom": "Activité 2 - 16 janvier 2020",
            "Debut": "2020-01-16T17:30:00",
            "Fin": "2020-01-17T17:29:00",
            "Description": "À l’aube de cette nouvelle année, quoi de mieux que de se rassembler pour célébrer et échanger sur nos objectifs pour l’année à venir ? ",
            "PolitiqueAnnulation": "<strong>Aucune annulation ni remboursement moins de deux (2) jours ouvrables avant l’événement.&nbsp;</strong>",
            "NbPlaceDisponibles": 20,
        },
        {
            "Id": 257,
            "EvenementNom": "Activité 3 - 16 janvier 2020",
            "Debut": "2020-01-16T17:30:00",
            "Fin": "2020-01-17T17:29:00",
            "Description": "À l’aube de cette nouvelle année, quoi de mieux que de se rassembler pour célébrer et échanger sur nos objectifs pour l’année à venir ? ",
            "PolitiqueAnnulation": "<strong>Aucune annulation ni remboursement moins de deux (2) jours ouvrables avant l’événement.&nbsp;</strong>",
            "NbPlaceDisponibles": 0,
        }],
    tarifs: [
        {
            "Libelle": "Billet - Membre",
            "TypeTarif": "Membre",
            "Categorie": "PYenM4bsYQSW7iuXBtNBLQR1EpL1R1EpL1",
            "NombreDeBillets": 0,
            "Prix": 60,
            "Ordre": 0,
            "Id": "R1EpL3KR1EpL4zd2cPHSdBHXYHkFLBgwR1EpL1R1EpL1"
        },
        {
            "Libelle": "Billet - Non membre",
            "TypeTarif": "NonMembre",
            "Categorie": "PYenM4bsYQSW7iuXBtNBLQR1EpL1R1EpL1",
            "NombreDeBillets": 0,
            "Prix": 100,
            "Ordre": 1,
            "Id": "R1EpL3KR1EpL4zd2cPHSdBHXYHkFLBgwR1EpL1R1EpL1"
        }
    ]
}